import {STATUS} from '@jobseeker/common-core/constants';
import axiosInterceptorInstance from '@jobseeker/common-core/helpers/axiosInterceptor';
import moment from 'moment';
import qs from 'qs';

const axios = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_USER_SERVICE}/interviews`
);

const getSlots = async (
  booked?: 0 | 1 | 2,
  pageNumber?: number,
  pageContent?: number
): Promise<any> => {
  try {
    const response: any = await axios.get('slots', {
      params: {booked, pageNumber, pageContent},
    });
    if (response[STATUS] === 200) {
      return response['data'];
    }
    return {data: []};
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data.error.message,
        code: error.response?.data.error.statusCode,
      },
    };
  }
};

const getSlotDetailsById = async ({
  calendarId,
  slotId,
}: {
  calendarId: string;
  slotId: string;
}): Promise<any> => {
  try {
    const response: any = await axios.get('slot-by-slotid', {
      params: {
        calendarId,
        slotId,
      },
    });
    if (response[STATUS] === 200) {
      return response.data;
    }
    return {data: {}};
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data.error.message,
        code: error.response?.data.error.statusCode,
      },
    };
  }
};

const getSlotsCount = async ({
  calendarId,
  slotId,
}: {
  calendarId: string;
  slotId: string;
}): Promise<any> => {
  try {
    const response: any = await axios.get('slots-count', {
      params: {
        calendarId,
        slotId,
      },
    });
    if (response[STATUS] === 200) {
      return response.data;
    }
  } catch (error: any) {
    console.log(
      `${moment()} - Error occurred while fetching one months' slots count`
    );
    console.log({error});
  }
  return {count: 0, status: 'success', message: ''};
};

const getSlotDetails = async ({
  calendarId,
  slotId,
  from,
  to,
}: {
  calendarId: string;
  slotId: string;
  from: string;
  to?: string;
}): Promise<any> => {
  try {
    const response: any = await axios.get('slot-details', {
      params: {
        calendarId,
        slotId,
        from,
        to,
      },
    });
    if (response[STATUS] === 200) {
      return response.data;
    }
    return {data: {}};
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data.error.message,
        code: error.response?.data.error.statusCode,
      },
    };
  }
};

const getSlotTimings = async (queryParams: {
  calendarId: string;
  slotId: string;
  date: string;
  toDate?: string;
  meridiem?: 'am' | 'pm';
}): Promise<any> => {
  try {
    const response: any = await axios.get('slot-timings', {
      params: {...queryParams, format: 'nested'},
    });
    if (response[STATUS] === 200) {
      return response.data;
    }
    return {data: {}};
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data.error.message,
        code: error.response?.data.error.statusCode,
      },
    };
  }
};

const confirmInterview = async (confirmInterviewInfo: {
  calendarId: string;
  slotId: string;
  dateSlot: string;
  timeSlot: string;
  reschedule?: number;
  recruiterId?: number;
}) => {
  try {
    const response = await axios.post(
      '/confirm-slot',
      qs.stringify(confirmInterviewInfo)
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data?.error?.message || 'Unknown error',
        code: error.response?.data?.error?.statusCode || 500,
      },
    };
  }
};

const cancelInterview = async (cancelInterviewInfo: {
  calendarId: string;
  slotId: string;
  recruiterId: number;
}) => {
  try {
    const response = await axios.post(
      'cancel-slot',
      qs.stringify(cancelInterviewInfo)
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data?.error?.message || 'Unknown error',
        code: error.response?.data?.error?.statusCode || 500,
      },
    };
  }
};

const notifyRecruiterAboutNoAvailableSlots = async (payload: {
  slotId: string;
  jobId: number;
  recruiterId: number;
}) => {
  try {
    const response = await axios.post('notify-recruiter', payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data?.error?.message || 'Unknown error',
        code: error.response?.data?.error?.statusCode || 500,
      },
    };
  }
};

const interviewService = {
  getSlotDetailsById,
  getSlots,
  getSlotDetails,
  getSlotTimings,
  confirmInterview,
  cancelInterview,
  getSlotsCount,
  notifyRecruiterAboutNoAvailableSlots,
};

export default interviewService;
